export default {
  content: {
    title: '¡Gracias!',
    description: 'Has hecho tu buena acción del día haciendo feliz a {{firstName}}',
  },
  joinCommunity: '¿Por qué no unirse a la comunidad?',
  downloadButton: 'Descargar SOSAFE',
  contactAgain: 'Contactar nuevamente a {{firstName}}',
};
